import type { ApiErrorEnvelope } from '~/api/types'
import { MESSAGES } from '~/components/Charts/chrome/chartChrome'

export type ErrorTier = 'inline' | 'toast' | 'boundary' | 'dev-only'
export type ErrorAction = 'none' | 'retry' | 'relogin' | 'reset'

export interface ClassifiedError {
  tier: ErrorTier
  action: ErrorAction
  userMessage: string
}

const map: Record<string, { tier: ErrorTier; action: ErrorAction; userMessage?: string }> = {
  'S-NO-JWT': { tier: 'toast', action: 'relogin' },
  'S-BAD-SIG': { tier: 'toast', action: 'relogin' },
  'S-NO-CUSTOMER': { tier: 'boundary', action: 'reset' },
  'S-UNKNOWN-CUSTOMER': { tier: 'boundary', action: 'reset' },
  'S-UPSTREAM-TLS': { tier: 'toast', action: 'retry' },
  'S-UPSTREAM-DOWN': { tier: 'toast', action: 'retry' },
  PGRST200: { tier: 'inline', action: 'none' },
  '42501': { tier: 'inline', action: 'none' },
  '23503': { tier: 'inline', action: 'none' },
  '23505': {
    tier: 'inline',
    action: 'none',
    userMessage: MESSAGES.duplicateNameError,
  },
  '57014': {
    tier: 'inline',
    action: 'retry',
    userMessage: MESSAGES.timeframeTooLarge,
  },
}

export function classifyError(envelope: ApiErrorEnvelope): ClassifiedError {
  const entry = map[envelope.code]
  const fallback = envelope.hint ? `${envelope.message} (${envelope.hint})` : envelope.message
  if (entry) {
    return { tier: entry.tier, action: entry.action, userMessage: entry.userMessage ?? fallback }
  }
  return { tier: 'toast', action: 'none', userMessage: fallback }
}
